export enum B2BType {
    DEFAULT = 'default',
    GOV = 'gov',
    NGO = 'ngo'
}

export type B2BContactFormType = {
    email: string
    /** What they need; the form's only other field. */
    description?: string
    fullName?: string
    phone?: string
    orgType?: string
    requestType?: string
    /** Where the form was sent from, e.g. /talentbase/pre-firmy. */
    page?: string
    /** Honeypot: hidden from people, filled in by bots. */
    website?: string
}
